import { render, staticRenderFns } from "./line-height.vue?vue&type=template&id=00edb29e&"
import script from "./line-height.vue?vue&type=script&lang=js&"
export * from "./line-height.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports